import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Postdata } from "../../helpers/api.service";
import HttpService from "../../helpers/httpServices";
import { message } from "../../redux/actions/toastActions";
import { Topbar } from "../../components/include/Topbar";
import { isPermission, isRole, isRoleType } from "../../redux/selectors/authSelector";
import Error403Page from "../ErrorPage";
import { toast } from "sonner";
import { useCountryNavigate } from "../../components/common/UseCountryNavigate";

const Add_subject = () => {
  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);
  const location = useLocation();
  // const navigate = useNavigate();
  const navigate = useCountryNavigate();
  const dispatch = useDispatch();
  const params = useParams();

  const [formData, setFormData] = useState({
    name: "",
    department: "",
    books: "",
    approach: "",
  });
  const permissions = useSelector(isPermission);
  const role = useSelector(isRole);
  const role_type = useSelector(isRoleType);

  console.log("permissions", permissions);
  const isAccessible =
    role === "admin" ||
    role === "subadmin" ||
    role == "schooladmin" ||
    (permissions && (permissions?.includes("edit_Education") || permissions?.includes("edit_School"))) ||
    false;
  // At the top of your component
  const [bookInput, setBookInput] = useState(""); // temporary input for books
  const [booksList, setBooksList] = useState(
    formData.books ? formData.books.split(",") : []
  );
  const schoolId = localStorage.getItem("activeSchoolId");
  const mode = localStorage.getItem("mode");
  const { id } = useParams();
  const validate = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = true;
    if (!formData.department) newErrors.department = true;
    if (!formData.books) newErrors.books = true;
    // if (booksList) newErrors.books = true;
    if (!formData.approach) newErrors.approach = true;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (
      (name === "name" || name === "department") &&
      !/^[A-Za-z ]*$/.test(value)
    ) {
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoader(true);

    const form = new FormData();
    if (params.id) form.append("id", params.id);
    form.append("name", formData.name);
    form.append("department", formData.department);
    form.append("books", formData.books);
    // form.append("books", booksList.join(","));
    form.append("approach", formData.approach);
    form.append("school_id", schoolId);
    Postdata(HttpService.subject_add, form).then((res) => {
      if (res.status === 200) {
        toast.success(res.message);

        if (role === "admin" || role === "subadmin" || role_type === "schoolsubadmin" || role_type === "subadmin") {
          if (mode === "view") {
            navigate(`admin-school/view/${schoolId}`, {
              state: { mainTab: "Education", currentTab: "Subjects" },
            });
          } else {
            navigate("navigation-dashboard", {
              replace: true,
              state: { mainTab: "Education", currentTab: "Subjects" },
            });
          }
        } else {
          navigate(`education`, {
            replace: true,
            state: { currentTab: "Subjects" },
          });
        }
      }
      // dispatch(message(res.message));
      setLoader(false);
    });
    console.log("Submitted as FormData:", formData);
  };

  const fetchData = () => {
    setLoader(true);
    Postdata(HttpService.subject_show, {
      id: params.id,
      school_id: schoolId,
    }).then((res) => {
      if (res.status === 200) {
        setFormData({
          name: res.data.name,
          department: res.data.department,
          books: res.data.books,
          approach: res.data.approach,
        });
        setBooksList(res.data.books.split(","));
      }
      // else {
      //     dispatch(message(res.message));
      // }
    });
    setLoader(false);
  };

  // Handle book input change
  const handleBookInputChange = (e) => setBookInput(e.target.value);

  // Handle Tab key for adding book as a tag
  const handleBookKeyDown = (e) => {
    if (e.key === "Tab" && bookInput.trim() !== "") {
      e.preventDefault();
      if (!booksList.includes(bookInput.trim())) {
        setBooksList([...booksList, bookInput.trim()]);
      }
      setBookInput("");
    }
  };

  // Remove a book tag
  const removeBook = (book) => {
    setBooksList(booksList.filter((b) => b !== book));
  };

  useEffect(() => {
    if (location.state?.type === "edit") {
      fetchData();
    }
  }, []);

  if (!isAccessible) {
    return <Error403Page />;
  }

  return (
    <>
      <Topbar
        title={location.state?.type == "edit" ? "Edit Subject" : "Add Subject"}
        aerrow={true}
      />

      <div className="p-6 bg-gray-100 min-h-screen">
        <form onSubmit={(e) => handleSubmit(e)}>
          {/* Inline Inputs */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {/* Performance Year */}
            <div>
              <label className="block mb-1 font-medium text-gray-700">
                Subject Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="name"
                placeholder="Enter Subject Name"
                className="input-field"
                value={formData.name}
                onChange={handleInputChange}
                maxLength={50}
                required
              />
              {errors.name && (
                <span className="text-red-500 text-sm">
                  Subject Name is Required
                </span>
              )}
            </div>

            <div>
              <label className="block mb-1 font-medium text-gray-700">
                Department <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="department"
                placeholder="Enter Department"
                className="input-field"
                value={formData.department}
                onChange={handleInputChange}
                maxLength={50}
                required
              />
              {errors.department && (
                <span className="text-red-500 text-sm">
                  Department is Required
                </span>
              )}
            </div>
          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-700">
              Recommended Books<span className="text-red-500">*</span>
            </label>
            <textarea
              name="books"
              placeholder="Write Here"
              className="input-field"
              value={formData.books}
              onChange={handleInputChange}
            />
            {/* <div className="flex flex-wrap gap-2 p-2 border rounded">
                            {booksList.map((book, idx) => (
                                <div key={idx} className="bg-primary_main text-white px-2 py-1 rounded flex items-center gap-1">
                                    {book}
                                    <span
                                        className="cursor-pointer font-bold"
                                        onClick={() => removeBook(book)}
                                    >
                                        ×
                                    </span>
                                </div>
                            ))}
                            <input
                                type="text"
                                value={bookInput}
                                onChange={handleBookInputChange}
                                onKeyDown={handleBookKeyDown}
                                placeholder="Type a book name and press Tab"
                                className="flex-1 outline-none"
                            />
                        </div> */}
            {errors.books && (
              <span className="text-red-500 text-sm">
                Recommended Books is Required
              </span>
            )}
          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-700">
              School Teaching Approach<span className="text-red-500">*</span>
            </label>
            <textarea
              name="approach"
              placeholder="Write Here"
              className="input-field"
              value={formData.approach}
              onChange={handleInputChange}
            />
            {errors.approach && (
              <span className="text-red-500 text-sm">
                School Teaching Approach is Required
              </span>
            )}
          </div>

          <div className="w-full flex justify-center gap-3 mb-2 mt-4">
            <button
              type="submit"
              className="button-field-primary"
              style={{ width: "30%" }}
              disabled={loader}
            >
              {loader
                ? "Please wait..."
                : location.state?.type == "edit"
                  ? "Save"
                  : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default Add_subject;
